import { createGlobalState } from '@vueuse/core'
import { computed, reactive, ref, toRefs } from 'vue'
import type { ErrorCode, ErrorSeverity } from '~shared/types/error'
import { useAuth } from './useAuth'

export interface AppError {
  id: string
  code: ErrorCode
  message: string
  severity: ErrorSeverity
}

export const useState = createGlobalState(() => {
  const { hasPatreonTier } = useAuth()

  const state = reactive({
    usp: false,
    gdpr: false,
    adsEnabled: computed(() => !hasPatreonTier(1)),
  })

  const _errors = ref<AppError[]>([])

  return {
    ...toRefs(state),
    addError: (code: ErrorCode, message: string, severity: ErrorSeverity = 'error') => {
      _errors.value.push({
        id: crypto.randomUUID(),
        code,
        message,
        severity,
      })
    },
    removeError: (id: string) => {
      _errors.value = _errors.value.filter((error) => error.id !== id)
    },
    errors: computed(() => _errors.value),
  }
})
